import React from "react" 

const HelpCenter =() => {
    return(
    <div> Help Center  </div>
    )
};

export default HelpCenter;